import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import withStyle, {
  RequiredStyled,
  HintStyled,
  HoverableInfoIconStyled,
} from './InputLabel.style'

const InputLabel = ({
  label,
  hint,
  tooltip,
  htmlFor,
  required,
  className,
  tooltipAutoWidth,
  tooltipPosition,
  isSVGTooltip,
  icon,
  tooltipOverlayStyle,
  tooltipOverlayClassName,
  tooltipAlign,
}) => (
  <label className={className} htmlFor={htmlFor}>
    {required && <RequiredStyled>*</RequiredStyled>}
    {label}
    {hint && <HintStyled>({hint})</HintStyled>}
    {tooltip && (
      <HoverableInfoIconStyled
        overlayClassName={classNames(
          {
            autoWidth: tooltipAutoWidth,
            'svg-tooltip': isSVGTooltip,
          },
          tooltipOverlayClassName
        )}
        tooltip={tooltip}
        centerLeft
        tooltipPosition={
          tooltipPosition || (tooltipAutoWidth ? 'topRight' : 'top')
        }
        icon={icon}
        overlayStyle={tooltipOverlayStyle}
        align={tooltipAlign}
      />
    )}
  </label>
)

InputLabel.defaultProps = {
  size: 'default',
  weight: 'normal',
  htmlFor: '',
  tooltipAutoWidth: false,
  isSVGTooltip: false,
}

InputLabel.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  icon: PropTypes.string,
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
  ]),
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  vertical: PropTypes.bool,
  size: PropTypes.string,
  weight: PropTypes.oneOf(['bold', 'normal']),
  tooltipAutoWidth: PropTypes.bool,
  tooltipPosition: PropTypes.string,
  isSVGTooltip: PropTypes.bool,
  tooltipOverlayStyle: PropTypes.object,
  tooltipOverlayClassName: PropTypes.string,
  tooltipAlign: PropTypes.object,
}

export default withStyle(InputLabel)
